module.exports = __webpack_public_path__ + "img/djbk_banner.eca72d24.png";